import { ReactNode } from "react";
import { Link } from "react-router-dom";
import SEO from "./SEO";
import Footer from "./Footer";

interface PageLayoutProps {
  children: ReactNode;
  seo: {
    title: string;
    description: string;
    canonical: string;
    noindex?: boolean;
    schema?: object;
  };
  /** Max width class for content container */
  maxWidth?: "sm" | "md" | "lg";
  /** Whether to show compact footer */
  compactFooter?: boolean;
}

const maxWidthClasses = {
  sm: "max-w-xl",
  md: "max-w-2xl",
  lg: "max-w-4xl",
};

/**
 * Shared layout for content pages (About, FAQ, Privacy, Terms)
 * Provides consistent header, footer, and SEO handling
 */
const PageLayout = ({ 
  children, 
  seo, 
  maxWidth = "md",
  compactFooter = true 
}: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEO {...seo} />

      {/* Header */}
      <header className="py-6 px-6 border-b border-border/30">
        <div className={`${maxWidthClasses[maxWidth]} mx-auto`}>
          <Link 
            to="/" 
            className="font-serif text-xl md:text-2xl text-foreground hover:text-primary transition-colors"
          >
            Eunice
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 px-4 md:px-6 py-12 md:py-16">
        <div className={`${maxWidthClasses[maxWidth]} mx-auto`}>
          {children}
        </div>
      </main>

      <Footer variant={compactFooter ? "compact" : "default"} />
    </div>
  );
};

export default PageLayout;
